import React, { useEffect, useState } from "react";
import ss from "./Cipher.module.css";

export default function Cipher(props) {
  const { onCipherComplete } = props;
  const [password, setPassword] = useState();
  const [pass, setPass] = useState(["", "", "", ""]);

  // 监听password的变化
  useEffect(() => {
    const newPass = Array(4)
      .fill("")
      .map((_, index) => {
        // return index < password.length ? "*" : "";
        return index < (password && password.length) ? "*" : "";
      });
    setPass(newPass);
  }, [password]);

  // 假设有一个函数来更新password
  const handlePasswordChange = (e) => {
    setPassword(e.target.value.slice(0, 4));
  };

  useEffect(() => {
    if (password) {
      onCipherComplete(password);
    }
    // eslint-disable-next-line
  }, [password]);

  return (
    <div className={ss.cipher_box}>
      <input
        className={ss.cipher_input}
        type="number"
        value={password}
        onChange={(e) => handlePasswordChange(e)}
      />
      {pass.map((value, index) => {
        return (
          <div key={index} className={ss.cipher}>
            {value}
          </div>
        );
      })}
    </div>
  );
}
